import { Card, Typography } from '@mui/material';
import { Spacer } from '@sparemin/blockhead';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  display: flex;
  gap: 32px;
  flex-direction: column;
  align-items: center;
`;

export const ReviewItemsContainer = styled(Spacer)`
  width: 100%;
`;

export const CreditsSummary = styled(Card)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 24px;
  border-color: #bec8d2;
  background-color: ${({ theme }) => theme.palette.l1};
`;

export const CreditSummaryRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const CreditApplied = styled(Typography)`
  width: fit-content;
  padding: 4px 8px;
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.common.white};
  background-color: ${({ theme }) => theme.palette.actionSecondary.main};
`;
